<template>
    <Modal
        no-actions
        class="!w-auto"
    >
        <vue-recaptcha
            ref="recaptcha"
            :sitekey="siteKey"
            load-recaptcha-script
            @verify="onVerify"
            @expired="onExpired"
        />
    </Modal>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import ModalMixin from '@mixins/modalMixin';
import Modal from '@components/Modal';
import { storeCaptcha, updateVerifiedCaptcha } from '@/api/backend/captcha';

/**
 * @emits close with token if successfully verified
 */
export default {
    name: 'ModalCaptcha',
    components: {
        Modal,
        VueRecaptcha,
    },
    extends: ModalMixin,
    props: {
        context: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            storedCaptchaId: null,
        };
    },
    computed: {
        siteKey() {
            return `${import.meta.env.MIX_RECAPTCHA_SITE_KEY}`;
        },
    },
    created() {
        storeCaptcha(this.context).then((response) => {
            this.storedCaptchaId = response.data.id;
        });
    },
    methods: {
        onExpired() {
            this.$refs.recaptcha.reset();
        },
        async onVerify(token) {
            await updateVerifiedCaptcha({ captchaId: this.storedCaptchaId });
            this.close(token);
        },
    },
};
</script>
